module.exports = __webpack_public_path__ + "img/0xa184088a740c695e156f91f5cc086a06bb78b827.7c6c04cf.png";